/* global axios */
import ApiClient from './ApiClient';

class DepartmentsAPI extends ApiClient {
  constructor() {
    super('departments', { accountScoped: true, apiVersion: 'v2' });
  }

  getMembers(departmentId) {
    return axios.get(`${this.url}/${departmentId}/members`);
  }

  addMember(departmentId, userId) {
    return axios.post(`${this.url}/${departmentId}/members`, {
      user_id: userId,
    });
  }

  removeMember(departmentId, memberId) {
    return axios.delete(`${this.url}/${departmentId}/members/${memberId}`);
  }

  // GK-HUB: Fetch agents belonging to a department's teams
  getAgents(departmentId) {
    return axios.get(`${this.url}/${departmentId}/agents`);
  }
}

export default new DepartmentsAPI();
